<template>
  <div class="login">
    <div class="title">{{ $t('resetYourPassword') }}</div>

    <div class="info">
      {{ $t('forgotPassword.secretQuestionsInfo') }}
    </div>

    <VeeForm v-slot="{ errors }" @submit="register">
      <Transition name="fade">
        <div v-if="error || Object.keys(errors).length > 0" class="error-container">
          <div class="error-icon">!</div>
          <div v-if="error" class="error-text">{{ error }}</div>
          <div v-else-if="errors['answer']" class="error-text">{{ $t('errorMessage.secretQuestionInvalid') }}</div>
        </div>
      </Transition>

      <div class="input-container">
        <div class="label-container">
          <div class="label">{{ $t('secretQuestion') }}</div>
        </div>
        <div class="secret-question no-select">
          {{ secretQuestion.value }}
        </div>
      </div>

      <div class="input-container">
        <div class="label-container">
          <div class="label">{{ $t('answer') }}</div>
        </div>

        <Field name="answer" rules="required:min:6" type="text" :placeholder="$t('answer')" />
      </div>

      <button class="study-button main" :class="{ loading: loading }">
        {{ loading ? $t('loading') : $t('continue') }}
      </button>
    </VeeForm>

    <RouterLink :to="{ name: 'userLogin' }" class="text-button">{{ $t('alreadyOwnAnAccountAndPassword') }}</RouterLink>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Field, Form as VeeForm } from 'vee-validate';

export default {
  components: {
    Field,
    VeeForm,
  },

  data() {
    return {
      error: null,
      loading: false,
      secretQuestion: { value: null, language: 'FR' },
    };
  },

  computed: {
    ...mapGetters({
      userLanguage: 'userLanguage',
    }),
  },

  watch: {
    userLanguage() {
      this.getClientSecretQuestion();
    },
  },

  mounted() {
    this.getClientSecretQuestion();
  },

  methods: {
    getClientSecretQuestion() {
      this.$store.dispatch('getClientSecretQuestion', this.$route.params.token).then(secretQuestion => {
        this.secretQuestion = secretQuestion;
      });
    },

    register(values) {
      if (this.loading) return;
      this.loading = true;
      this.error = null;

      const resetInfo = {
        token: this.$route.params.token,
        question: this.secretQuestion.value,
        answer: values.answer,
      };

      this.$store
        .dispatch('setClientResetInfo', resetInfo)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: 'userResetPassword', params: { token: this.$route.params.token } });
        })
        .catch(e => {
          this.loading = false;
          switch (e.code) {
            default:
              this.error = e.error;
              break;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/register.scss';
</style>
